import $ from 'jquery';
import pageScripts from './pages';
import 'what-input';
import { Foundation } from 'foundation-sites';
import { Reveal } from 'foundation-sites/js/foundation.reveal';

$(document).foundation();

$( document ).ready( function () {
	//Require all components here.
	require( './components/foundation' );
    
});


//Require all components here.

$( ".input-name" ).parent().addClass("input-wrap");
$( ".input-email" ).parent().addClass("input-wrap");
$( ".input-radio" ).parent().parent().addClass("radio-wrap");
$( ".input-radio" ).parent().addClass("radio-inner-wrap");
$( ".input-field" ).parent().addClass("wrapper-input-field");

$("#breadcrumbs .bread-custom-post-type-services").removeAttr('href');


$( ".address-field" ).parent().addClass("address-wrapper");
$( ".address-wrapper" ).wrapAll( "<div class='address-group'></div>" );
$( ".input-wrap" ).wrapAll( "<div class='input-group'></div>" );
$( ".wrapper-input-field" ).wrapAll( "<div class='inputs-group'></div>" );

$("#slider-owl").owlCarousel({
    loop:true,
    margin:0,
    responsiveClass:true,
    mouseDrag: true,
    dots: false,
    nav: false,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: true,
    autoplayHoverPause:false,
    responsive:{
    0:{
        items:1,
    },
    600:{
        items:1,
    },
    1000:{
        items:1,
        loop:true
    }
}
});

$("#services-owl").owlCarousel({
    loop:true,
    margin:20,
    responsiveClass:true,
    mouseDrag: true,
    dots: false,
    nav: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut', 
    autoplayHoverPause:true,
    responsive:{
    0:{
        items:1,
    },
    600:{
        items:2,
    },
    1000:{
        items:3,
        loop:true
    }
}
});

$("#team-owl").owlCarousel({
    loop:true,
    margin:8,
    responsiveClass:true,
    mouseDrag: true,
    dots: false,
    nav: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut', 
    autoplayHoverPause:true,
    responsive:{
    0:{
        items:1,
    },
    600:{
        items:2,
    },
    1000:{
        items:3,
        loop:true
    }
}
});

$("#news-owl").owlCarousel({
    loop:true,
    margin:15,
    responsiveClass:true,
    mouseDrag: true,
    dots: false,
    nav: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    autoplay: true,
    animateIn: 'fadeIn',
    animateOut: 'fadeOut', 
    autoplayHoverPause:true,
    responsive:{
    0:{
        items:1,
    },
    600:{
        items:2,
    },
    1000:{
        items:2,
        loop:true
    }
}
});